import './_import-header.scss';
import React from 'react';
import { Button } from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import SearchInput from '../../../../../../../../../components/Search/SearchInput';

import * as importTypes from '../../../reducer/constants';

const Header = ({ search, dispatchImportState, hideAdded }) => {
  const onChangeSearch = (e) => {
    const { value } = e.target;
    dispatchImportState({ type: importTypes.IMPORT_CHANGE_SEARCH, value });
  };

  const onToggle = () => {
    dispatchImportState({ type: importTypes.IMPORT_TOGGLE_ADDED_VISIBLE });
  };

  return (
    <div className="services-import__header">
      {!search.trim() && (
        <div className="services-import__header-left">
          <Button bsStyle="link" className="services-import__header-toggler" onClick={onToggle}>
            <span className={classNames('fas', {
              'fa-eye-slash': !hideAdded,
              'fa-eye': hideAdded,
            })}
            />
            {hideAdded ? 'Show' : 'Hide'}
            {' '}
            added services
          </Button>
        </div>
      )}
      <div className="services-import__header-right">
        <div className="services-import__header-search">
          <SearchInput onChange={onChangeSearch} value={search} placeholder="Search" />
        </div>
      </div>
    </div>
  );
};

Header.propTypes = {
  search: PropTypes.string,
  dispatchImportState: PropTypes.func,
  hideAdded: PropTypes.bool,
};
export default Header;
